import axios from "axios";
import { useEffect, useState } from "react";
import { redirect } from "react-router-dom";
import UserNavbar from "../../components/UserNavBar";
import { toast } from "react-toastify";
import base_url from "../../Utils/server";

export function loader({ req }) {
  console.log(sessionStorage.getItem("jwtToken") == null);
  if (sessionStorage.getItem("jwtToken") == null) {
    throw redirect("/?message=PleaseLogin");
  }
  return null;
}

function Userconnect() {
  const [connection, setConnection] = useState([]);

  const Token = sessionStorage.getItem("jwtToken");
  useEffect(() => {
    axios
      .get(`${base_url}/connections`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      })
      .then((res) => {
        if(res.data.status=="success"){
          setConnection(res.data.data);
        }
        else{
          toast.error(res.data.message);
        }
      })
      .catch((e) => {
        toast.error("Error Fetching details");
      });
  }, []);
  function handledisconnections(e, name) {
    const id = toast.loading("Deleting Connection", {
      position: toast.POSITION.TOP_RIGHT,
    });
    axios
      .delete(`${base_url}/unfollow/user/${name}`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      })
      .then((res) => {
        e.target.innerText = "Disconnected";
        e.target.style.backgroundColor = "black";
        e.target.style.color = "white";
        toast.update(id, {
          render: "Connection Deleted Successfully",
          type: "success",
          isLoading: false,
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1500,
        });
        setTimeout(() => {
          axios
            .get(`${base_url}/connections`, {
              headers: {
                Authorization: `Bearer ${Token}`,
              },
            })
            .then((res) => {
              setConnection(res.data.data);
              e.target.style.backgroundColor = "white";
              e.target.style.color = "black";
              e.target.innerText = "Disconnect";
            })
            .catch((e) => {
              toast( "Error Deleting Connection");
            });
        }, 2000);
      })
      .catch((e) => {
        toast.update(id, {
          render: "Error Deleting Connection",
          type: "error",
          isLoading: false,
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
      });
  }

  return (
    <>
      <UserNavbar />
      <div className="max-w-screen-xl mx-auto px-4 md:px-8">
        <div className="max-w-lg">
          <h3 className="text-gray-800 pt-10 text-xl font-bold sm:text-2xl">
            Your Connections
          </h3>
        </div>
        <div>
          {connection.length == 0 ? (
            <span className="block mt-12 pb-6 text-gray-500 text-xl  font-semibold mb-4">
              No Connections to Show. Please Add New Connections
            </span>
          ) : (
            ""
          )}
          {connection.length > 0 && (
            <table className="w-full table-auto text-sm text-left">
              <thead className="bg-gray-50 text-gray-600 font-medium border-b">
                <tr>
                  <th className="py-3 px-6">User ID</th>
                  <th className="py-3 px-6">User Name</th>
                  <th className="py-3 px-6">Disconnect</th>
                </tr>
              </thead>
              <tbody className="text-gray-600 divide-y">
                {connection.length > 0 &&
                  connection.map((item, idx) => (
                    <tr key={idx} className="opac-control">
                      <td className="flex items-center gap-x-3 py-3 px-6 whitespace-nowrap">
                        <img
                          src={item.profileImage}
                          className="w-10 h-10 rounded-full"
                        />
                        <span className="block text-gray-700 text-xs">
                          {item.userName}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className="block text-gray-700 text-xs">
                          {item.userFullName}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <button
                          className="block mt-px text-black border-2 border-black rounded-md px-4 py-2 text-sm"
                          onClick={(e) => {
                            handledisconnections(e, item.userName);
                          }}
                        >
                          Disconnect
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
}

export default Userconnect;
